import { useMutation, useQuery } from '@tanstack/react-query';
import { acceptOffer, getBankOptionsFn, getCustomerTypeFn, postPreferenceFormFn, saveFileFn, saveValidationFileFn } from '../../transactions/offer/offer';
import { QUERY_KEYS } from '../../config/constants';
import { saveCustomerFormFn } from '../../transactions/orders/orders';
import { saveKYCCustomerForm } from '../../transactions/kyc/kyc';
const { USER_TYPES } = QUERY_KEYS;

export const useUserTypes = () => {
  return useQuery({
    queryKey: [USER_TYPES],
    queryFn: getCustomerTypeFn,
    staleTime: Infinity,
    cacheTime: Infinity,
  });
};

export const useAcceptOffer = () => {
  return useMutation({
    mutationFn: (cncode) =>
      acceptOffer(cncode),
  });
}


export const useSaveCustomerForm = () => {
  return useMutation({
    mutationFn: (payload) =>
      saveCustomerFormFn(payload),
  });
}

export const useSaveKYCCustomerForm = () => {
  return useMutation({
    mutationFn: (payload) => 
      saveKYCCustomerForm(payload)
  })
}

export const useSaveFileFn = () => {
  return useMutation({
    mutationFn: (payload) =>
    saveFileFn(payload),
  })
}

export const usePostPreferenceFormFn = () => {
  return useMutation({
    mutationFn: (payload) => postPreferenceFormFn(payload)
  })
}

export const useSaveValidationFileFn = () => {
  return useMutation({
    mutationFn: (payload) => saveValidationFileFn(payload)
  })
}

export const useGetBankOptions = () => {
  return useQuery({
    queryKey: ['banks'],
    queryFn: getBankOptionsFn,
    staleTime: Infinity,
    cacheTime: Infinity,
  });
}